export default __webpack_public_path__ + "static/drought-1550e1fd0800022e4d864397816ef422.jpeg";